import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

export default (SettingsMenu) => {
	
	class SettingsMenuContainer extends PureComponent {

		render() {
			return <SettingsMenu {...this.props} />
		}

	}

	const mapStateToProps = (state, ownProps) => {
		// console.log(state.account);
		return {
			name: state.account.data ? state.account.data.name : '',
		}
	}

	return connect(mapStateToProps)(SettingsMenuContainer);

}




// WEBPACK FOOTER //
// ./src/components/SettingsMenu/SettingsMenuContainer.jsx